exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-breaker {\n  white-space: pre-line; }\n\n.mission-vision-wrapper {\n  margin-bottom: 424px; }\n\n.overflow-content {\n  height: auto;\n  overflow: visible; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/+web/modules/+about-us/about-us.component.scss
// module id = 1101
// module chunks = 28